
export default function TiemposCont({ fechaTexto, secondsElapsed}: 
                                {fechaTexto: any; secondsElapsed:any;}) {




return (

    <div className="game-meta" aria-label="Información de partida">
        <div className="game-meta__date" aria-live="polite">{ /* {today} */ } {fechaTexto}</div>
        <div className="game-meta__right">
          <time className="game-meta__timer" dateTime="PT45S">{secondsElapsed}</time>
          
        </div>
      </div>

    )
    



   
  
}